export default __webpack_public_path__ + "static/Respond quickly to weather changes and employee absences @2x-6d553d0e7c64e7cd8b73acfa7f17d042.png";